<template>
  <div>
    <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card class="ma-2 mt-5" v-else>
      <v-data-table
        :headers="empdata"
        dense
        :items="empitems"
        :search="search"
        class="mt-6"
        :no-data-text="Nodata"
      >
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ empitems.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.full_name`]="{ item }">
          <span class="caption"
            ><b>{{ item.full_name }}</b></span
          >
          <br />
          <span class="caption" v-if="item.mobile_no != null">{{
            item.mobile_no
          }}</span>
          <span class="caption" v-if="item.mobile_no == null">-</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small @click="viewemp(item)" color="primary">mdi-eye</v-icon>
          <v-icon small color="green" class="ml-4" @click="opentxn(item)"
            >mdi-cash-multiple</v-icon
          >
          <v-icon
            v-if="item.status == 'ACTIVE USER'"
            :disabled="item.is_req_pening != 0"
            small
            color="secondary"
            class="ml-4"
            @click="changeNumber(item)"
            >mdi-cellphone-text</v-icon
          >
        </template>
        <template v-slot:[`item.created_on`]="{ item }">
          <span class="caption" v-if="item.created_on != null">{{
            item.created_on
          }}</span>
          <span class="caption" v-else>-</span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span class="caption orange--text">{{ item.status }}</span>
        </template>
        <template v-slot:[`item.card_balance`]="{ item }">
          <span class="caption">{{ item.card_balance }}</span>
        </template>
        <template v-slot:[`item.card_details.card_type`]="{ item }">
          <span class="caption" v-if="item.card_details.card_type == 1"
            ><b>NON-Personalized</b></span
          >
          <span class="caption" v-if="item.card_details.card_type == 2"
            ><b>Personalized</b></span
          >

          <br />

          <span class="caption" v-if="item.card_details.sub_card_type == 1"
            >(Physical)</span
          >
          <span class="caption" v-if="item.card_details.sub_card_type == 2"
            >(Virtual)</span
          >
        </template>

        <template v-slot:top>
          <v-row class="ml-2 mt-2 mb-3 mr-2">
            <v-col cols="12" sm="12" xs="12" xl="3" md="3" lg="3">
              <v-text-field
                v-model="search"
                shaped
                outlined
                dense
                color="primary"
                append-icon="mdi-magnify"
                label="Search"
                hide-details
              ></v-text-field>
            </v-col>

            <v-spacer />
            <v-col cols="12" sm="12" xs="12" xl="2" md="2" lg="2">
              <v-btn
                class="elevation-0 white--text"
                @click="exportpdf()"
                v-if="empitems.length != 0"
                color="primary"
                :disabled="checkaccessdata.has_download == false"
              >
                <v-icon left dark>mdi-upload</v-icon>EXPORT
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>

    <viewemployee
      ref="viewemployee"
      v-on:backChild="getEmpDetails()"
      :approver1="approver1"
      :approver2="approver2"
    />
    <v-dialog persistent v-model="changenumberDialog" width="650">
      <v-card>
        <v-toolbar dark class="primary" dense>
          <v-toolbar-items>
            <v-toolbar-title
              class="white--text titcss ml-2 mt-3"
              style="font-size: 18px"
              >Mobile No. Change Request</v-toolbar-title
            >
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="closedialog()">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form ref="form">
            <v-row class="mt-8">
              <v-col cols="12" xl="4" lg="4" md="4">
                <v-text-field
                  label="User Name"
                  v-model="ChangeDetails.full_name"
                  class="ml-2 mr-2"
                  dense
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="4" lg="4" md="4">
                <v-text-field
                  label="Old Number"
                  v-model="ChangeDetails.mobile_no"
                  class="ml-2 mr-2"
                  dense
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="4" lg="4" md="4">
                <v-text-field
                  label="New Number *"
                  v-model="NewMobileNo"
                  class="ml-2 mr-2"
                  dense
                  outlined
                  prefix="+60"
                  :rules="[
                    (v) => !!v || 'Required',
                    (v) => /^[1-9][0-9]*$/.test(v) || 'Invalid Contact Number',
                    (v) => (v && v.length < 11) || 'Invalid Contact Number',
                    (v) => (v && v.length > 8) || 'Invalid Contact Number',
                  ]"
                  maxlength="10"
                ></v-text-field>
                <!-- @input="validateInput"
                  :color="redcolor"
                  :error="error"
                  :hint="invalidcontact" -->
              </v-col>
              <v-col cols="12" xl="12" lg="12" md="12">
                <v-textarea
                  label="Comments *"
                  v-model="comments"
                  class="ml-2 mr-2"
                  dense
                  outlined
                  rows="2"
                  :rules="commentRules"
                  maxlength="50"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary white--text" rounded @click="confirmRequest"
              >Request</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="actionCard" width="1100" persistent>
      <div>
        <v-toolbar flat class="header" dense dark>
          <v-icon>mdi-clipboard-text</v-icon>
          <span class="ml-3">Passbook Transactions &nbsp; - </span>
          <span class="font-weight-bold">
            &nbsp; {{ UserName }} ( {{ Mobile_no }})</span
          >

          <v-spacer></v-spacer>

          <v-btn icon @click="closedialogfunction">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card class="elevation-0" width="1100">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" xl="12" lg="12">
                <v-row wrap>
                  <v-col cols="12" sm="6" md="3" class="mt-1">
                    <label class="caption">From</label>
                    <v-dialog
                      ref="dialogStart"
                      v-model="modalStart"
                      :return-value.sync="start_date"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          outlined
                          elevation-5
                          color="primary"
                          dense
                          v-model="start_date"
                          placeholder="From"
                          append-icon="mdi-calendar"
                          readonly
                          v-on="on"
                          @click:append="date ? getcal() : getcal()"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="start_date"
                        scrollable
                        :max="maxEndDate"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalStart = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="
                
                    $refs.dialogStart.save(start_date);
                  "
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" class="mt-1">
                    <label class="caption">To</label>
                    <v-dialog
                      ref="dialogEnd"
                      v-model="modalEnd"
                      :return-value.sync="end_date"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          outlined
                          elevation-5
                          color="primary"
                          dense
                          v-model="end_date"
                          placeholder="To"
                          append-icon="mdi-calendar"
                          readonly
                          v-on="on"
                          @click:append="date ? getcal2() : getcal2()"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="end_date"
                        scrollable
                        :max="maxEndDate"
                :min="start_date"
                      
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalEnd = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialogEnd.save(end_date)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" sm="6" md="1" class="mt-1">
                    <v-btn
                      text
                      color="primary"
                      fab
                      @click="viewtxn()"
                      class="elevation-0 mt-3 ml-n3"
                    >
                      <v-icon>mdi-filter</v-icon>
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" sm="6" md="2" lg="2" class="mt-7 mr-3">
                    <v-col 
                      ><v-card  color="#EEEEEE" flat><v-row align="center" justify="center"
                        ><span class="caption"><b>Card Balance</b></span></v-row
                      ><v-row align="center" justify="center">
                        <div v-if="currentBalanceloading == false">
                          <b
                          
                            v-if="
                              currentBalance != null ||
                              currentBalance != '' ||
                              currentBalance != undefined
                              
                            "
                              class="green--text"
                            >MYR {{ currentBalance }}</b
                          >
                          <b class="green--text" v-else>NA</b>
                        </div>
                        <span
                          v-else
                          class="caption red--text font-weight-bold"
                          >Loading...</span
                        ></v-row
                      ></v-card></v-col
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="12" md="12" xl="12" lg="12">
                <v-data-table
                  :headers="txnheaders"
                  :items="cardtransactions"
                  dense
                  class="mt-n1"
                  :items-per-page="itemsPerPage"
                  :no-data-text="Nodatatxn"
                >
                  <template v-slot:[`item.sl_no`]="{ item }">
                    <span class="caption">{{
                      cardtransactions.indexOf(item) + 1
                    }}</span>
                  </template>
                  <template v-slot:[`item.trans_date`]="{ item }">
                    <span class="caption">{{ item.trans_date }}</span>
                  </template>
                  <template v-slot:[`item.bill_amount`]="{ item }">
                    <!-- <span class="caption">{{ item.bill_amount }}</span> -->
                    <div v-if="item.bill_amount != null">
                      <span
                        class="caption red--text"
                        v-if="item.bill_Flag == 'DR'"
                        >- {{ item.bill_amount }}
                      </span>

                      <span
                        class="caption green--text"
                        v-if="item.bill_Flag == 'CR'"
                        >+ {{ item.bill_amount }}
                      </span>
                    </div>
                    <div v-else>-</div>
                  </template>
                  <template v-slot:[`item.trans_Amount`]="{ item }">
                    <div v-if="item.bill_amount != null">
                      <span
                        class="caption red--text"
                        v-if="item.bill_Flag == 'DR'"
                      >
                        - {{ item.trans_Amount }}
                        <span style="font-size: 11px"></span>
                      </span>

                      <span
                        class="caption green--text"
                        v-if="item.bill_Flag == 'CR'"
                      >
                        + {{ item.trans_Amount }}
                        <span style="font-size: 11px"></span>
                      </span>
                    </div>
                    <div v-else>-</div>
                  </template>
                  <template v-slot:[`item.trans_currency`]="{ item }">
                    <!-- <span class="caption">{{ item.txn_amount }}</span> -->
                    <div v-if="item.trans_currency != null">
                      <span class="caption">{{ item.trans_currency }} </span>
                    </div>
                    <div v-else>-</div>
                  </template>
                  <!-- <template v-slot:[`item.trans_currency`]="{ item }">
                    <span class="caption ml-n8">{{ item.trans_currency }}</span>
                  </template> -->
                  <template v-slot:[`item.description`]="{ item }">
                    <span class="caption">{{ item.description }}</span>
                    <br />
                    <span class="caption">
                      <b>#Ref:</b> {{ item.trans_ref_no }}</span
                    >
                  </template>
                  <template v-slot:[`item.merchant_name`]="{ item }">
                    <span class="caption" v-if="item.merchant_name != ''">{{
                      item.merchant_name
                    }}</span>
                    <span class="caption" v-else>-</span>
                    <br />
                    <span class="caption" v-if="item.merchant_city != ''">{{
                      item.merchant_city
                    }}</span>
                  </template>

                  <template v-slot:[`item.running_balance`]="{ item }">
                    <span class="caption">{{ item.running_balance }}</span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="loader" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pt-2">
          {{ loaderMsg }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
import viewemployee from "@/Views/Employees/viewemployee.vue";
import moment from "moment";

export default {
  components: { viewemployee },
  data: () => ({
    comments: "",
    checkaccessdata: {},
    search: "",
    actionCard: false,
    locations: [],
    locationValue: "",
    moha: {},
    aml: {},
    approver1: {},
    approver2: {},
    blacklist: {},
    start_date: null,
    end_date: null,
    modalStart: "",
    modalEnd: "",
    cardtransactions: [],
    txnheaders: [
      { text: "Sl No", value: "sl_no", align: "start", sortable: false },
      {
        text: "Description",
        value: "description",
        align: "start",

        sortable: false,
      },
      {
        text: "Txn Date",
        value: "trans_date",

        sortable: false,
      },
      // {
      //   text: "Txn Ref No",
      //   value: "trans_ref_no",

      //   sortable: false,
      // },

      {
        text: "Txn Amt",
        value: "trans_Amount",
        align: "start",

        sortable: false,
      },
      {
        text: "Txn Ccy",
        value: "trans_currency",
        align: "start",

        sortable: false,
      },
      {
        text: "Billing Amt(MYR)",
        value: "bill_amount",
        align: "start",

        sortable: false,
      },
      {
        text: "Card Balance(MYR)",
        value: "running_balance",
        align: "start",

        sortable: false,
      },

      {
        text: "Merchant Name / Country",
        value: "merchant_name",

        sortable: false,
      },
    ],
    NewMobileNo: "",
    export: "",
    status: "",
    Namerules: [(v) => !!v || "Required"],
    commentRules: [
      (v) => !!v || "Required",
      (v) => /^(?=[a-zA-Z0-9 ]{0,51}$)[a-zA-Z0-9 ]{0,64}$/.test(v) || "Invalid",
    ],
    statuss: ["Active", "Locked", "Closed"],
    empdata: [
      { text: "SL NO", value: "sl_no" },
      {
        text: "NAME",
        value: "full_name",
      },
      {
        text: "CARD TYPE",
        value: "card_details.card_type",
      },
      // {
      //   text: "Employee ID",
      //   value: "empid",
      // },
      // {
      //   text: "CONTACT NUMBER",
      //   value: "mobile_no",
      // },
      {
        text: "ONBOARDED ON",
        value: "created_on",
      },

      // {
      //   text: "SUB-CARD TYPE",
      //   value: "card_details.sub_card_type",
      // },
      {
        text: "CARD BALANCE(MYR)",
        value: "card_balance",
      },
      {
        text: "STATUS",
        value: "status",
      },
      {
        text: "ACTION",
        value: "actions",
      },
    ],
    empitems: [],
    Nodata: "",
    ApproveArray: [],
    itemsPerPage: 25,
    ChangeDetails: {},
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    changenumberDialog: false,
    isInvalidInput: false,
    error: false,
    redcolor: "",
    invalidcontact: "",
    currentBalanceloading: true,
    currentBalance: "",
    UserName: "",
    Nodatatxn: "Click filter icon to get transactions",
    Mobile_no: "",
    maxEndDate: null,
    currentDate:null,
    loader: false,
    loaderMsg: "Please stand by",
  }),
  created() {
    this.checkaccess();
  },
  methods: {
    validateInput() {
      if (this.NewMobileNo.length >= 2) {
        const fifthChar = this.NewMobileNo[0]; // 5th character (0-indexed)
        // const sixthChar = this.NewMobileNo[1]; // 6th character (0-indexed)

        // if (fifthChar == 0 || sixthChar == 0) {
        if (fifthChar == 0) {
          this.redcolor = "red";
          this.error = true;
          this.invalidcontact = "Invalid Contact Number";
        } else {
          this.error = false;
          this.redcolor = "";
          this.invalidcontact = "";
        }
      } else {
        this.error = false;
      }
    },
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CUSERS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getEmpDetails();
      }
    },
    async exportpdf() {
      var inputData = {
        method_name: "SETTINGS",
        page_no: 0,
        record_count: 0,
        page_size: 100,
        app_code: "CPORTAL",
        method_param: {
          action: "EXCEL",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      try {
        var responseData = await apiCall(inputData, null, true);

        if (responseData.status == 200) {
          //console.log("responseData.data", responseData.data);
          var blob = new Blob([responseData.data]);
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `excelfile_${new Date().getTime()}.xlsx`;
          link.click();
        }
      } catch (error) {
        console.warn("Getting a Error", error);
      }
    },
    async card_getuserPagination() {
      if (this.empitems.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "BUDGET",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "GUSRBUDGET",
            search_text: "",
            corp_id: this.$store.getters.get_corpid,
            department_id: this.department_id,
          },
        };

        var responseData = await apiCall(inputData);

        this.empitems = this.empitems.concat(responseData.data.data);
      }
    },
    async viewtxnPagination() {
      if (this.cardtransactions.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "BUDGET",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "GETCUSTTXNS",
            corp_id: this.$store.getters.get_corpid,
            user_id: 0,
            search_text: "",
            from_date: null,
            to_date: null,
          },
        };

        var responseData = await apiCall(inputData);

        this.cardtransactions = this.cardtransactions.concat(
          responseData.data.data
        );
      }
    },
  async  opentxn(item) {
      this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
      this.end_date = new Date().toISOString().substr(0, 10);
      this.maxEndDate = moment().format("YYYY-MM-DD");
      this.actionCard = true;
      this.UserId = item.user_id;
      this.UserName = item.full_name;
      this.Mobile_no = item.mobile_no;
      this.Nodatatxn = "Click filter icon to get transactions";
      var inputData = {
        method_name: "CTRANS",
        page_no: 1,
        record_count: 0,
        page_size: 100,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCARDBAL",

          user_id: this.UserId,
       
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.currentBalanceloading = false;

        this.currentBalance = responseData.data.data.card_balance;
      } else if (responseData.data.status == "ERR") {
        this.currentBalanceloading = false;

        this.currentBalance = responseData.data.data.card_balance;
      } else {
        this.currentBalanceloading = true;
      }

    },
    async viewtxn() {
      this.loader = true;
  
   
      this.actionCard = true;
      var inputData = {
        method_name: "CTRANS",
        page_no: 1,
        record_count: 0,
        page_size: 100,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCUSTTXNS",

          user_id: this.UserId,
          search_text: "",
          from_date: this.start_date,
          to_date: this.end_date,
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
        this.loader = false;
          this.cardtransactions = responseData.data.data;
          // console.log(this.cardtransactions);
          this.totalCount = responseData.data.data[0].total_count;
        }
        this.overlay = false;
      } else {
        this.loader = false;
        this.cardtransactions = [];
        this.Nodatatxn = responseData.data.status_msg;
        this.overlay = false;
      }
      this.loader = false;
    },

    async getEmpDetails() {
      var inputData = {
        method_name: "ADMINCUST",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "CUSTVIEW",
          search_text: "",
          corp_id: this.$store.getters.get_corpid,
          type: "0",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responseData", responseData.data.data);
      if (responseData.data.status == "00") {
        this.empitems =
          responseData.data.data == null ? [] : responseData.data.data;
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.empitems = [];
      }
    },
    viewemp(item) {
      // alert(20);
      //  console.log(item);
      // console.log(JSON.parse(item.address).residential_address);
      this.$refs.viewemployee.empdialog = true;
      this.$refs.viewemployee.blacklist =
        JSON.parse(item.blacklist_scan) == null
          ? ""
          : JSON.parse(item.blacklist_scan);
      this.$refs.viewemployee.moha =
        JSON.parse(item.moha_scan) == null ? "" : JSON.parse(item.moha_scan);

      this.$refs.viewemployee.aml =
        JSON.parse(item.aml_scan) == null ? "" : JSON.parse(item.aml_scan);
      //
      this.$refs.viewemployee.userid = item.user_id;
      //  console.log(this.$refs.viewemployee.userid, "  this.viewemployee.userid");
      this.$refs.viewemployee.card = item.card_details;
      this.$refs.viewemployee.itemUsers = item.user_type;
      // console.log(item.user_type);

      // console.log(this.$refs.viewemployee.itemUser, "  this.viewemployee.itemUser");
      this.$refs.viewemployee.itemDetails = item;
      //  console.log("ew", this.$refs.viewemployee.itemDetails);
      this.approver1 = item.approver_one;
      this.approver2 = item.approver_two;

      //       this.NewObj =  this.$refs.viewemployee.itemDetails.approver_one;

      //  console.log(this.NewObj , "NewObj");
      //  this.ApproveArray = this.NewObj.department_name;
      // // this.ApproveArray = JSON.parse(this.NewObj).department_name;
      //       console.log(this.ApproveArray, "  ApproveArray");

      this.$refs.viewemployee.address = JSON.parse(
        item.address
      ).residential_address;
      this.$refs.viewemployee.address1 = JSON.parse(
        item.address
      ).mailing_address;

      var documentlist = {
        document_url: item.onfido_details.uploaded_url,
        DocumentName: this.getFileName(item.onfido_details.uploaded_url),
        DocumentExt: this.getExtension(item.onfido_details.uploaded_url),
      };
      // console.log("documentlist", documentlist);
      var reportUrllist = {
        report_url: item.onfido_details.report_url,
        reportName: this.getFileName(item.onfido_details.report_url),
        reportExt: this.getExtension(item.onfido_details.report_url),
      };
      this.$refs.viewemployee.documentlist = documentlist;
      this.$refs.viewemployee.reportUrllist = reportUrllist;
      // console.log(reportUrllist);
    },
    getFileName(filename) {
      //console.log("filename", filename);
      if (filename != null) {
        var url = filename.split("/");
        var len = url.length;
        const sample = url[len - 1];
        return sample;
      } else {
        return null;
      }
    },
    getExtension(filename) {
      //console.log("filename1", filename);
      if (filename != null) {
        var i = filename.lastIndexOf(".");
        return i < 0 ? "" : filename.substr(i).replace(".", "").toLowerCase();
      } else {
        return null;
      }
    },
    changeNumber(item) {
      this.ChangeDetails = item;
      this.changenumberDialog = true;
    },
    closedialog() {
      // this.$refs.form.reset();
      this.changenumberDialog = false;
      this.comments = "";
    },
    async confirmRequest() {
      if (this.$refs.form.validate() && this.error == false) {
        var inputData = {
          method_name: "CARDS",
          page_no: 1,
          record_count: 0,
          page_size: null,
          app_code: "CPORTAL",
          method_param: {
            action: "REQMOBCHANGE",
            search_text: "",
            user_id: this.ChangeDetails.user_id,
            mobile_number: this.NewMobileNo,
            initiated_from: 2,
            comments: this.comments,
            logged_user_id: this.$store.getters.get_userid,
          },
        };
        var responseData = await apiCall(inputData);

        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.closedialog();
          this.getEmpDetails();
        } else if (responseData.data.status == "FAIL") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
        }
      }
    },
    closedialogfunction() {
      this.actionCard = false;
      this.Nodatatxn = "";
      this.cardtransactions = [];
      this.currentBalance = "";
      this.currentBalanceloading = true;
    },
  
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
